import { useEffect, useState, useForm } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaPen, FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import useToken from '../../useToken';
import config from '../../config/config';
import axios from 'axios';
import { Link } from 'react-router-dom';

function BrandList() {
  const [error, setError] = useState(null);
  const [brand, setBrand] = useState([]);
  const { token, auth } = useToken();

  function deleteBrand(id) {
    axios
      .delete(`${config.deleteUrl}/brand/${id}`, { params: { id: id } })
      .then((response) => {
        setBrand((brand) => brand.filter((x) => x.id !== id));
      });
  }
  useEffect(() => {
    var auth = auth;
    axios.get(`${config.getUrl}/brand`).then((res) => {
      setBrand(res.data);
    });
  }, []);

  return (
    <div className="col-lg-12 mt-5">
      <Link className="btn lpbgColor mb-3" to="/brands/addbrand">
        Add Brands
      </Link>
      <div className="card o-hidden border-0 shadow-sm "> 
          <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {brand.map((i) => (
            <tr key={i.id}>
              <td>{i.name}</td>
              <td>
                <Link
                  className="text-primary mr-2"
                  to={`/brands/editbrand/${i.id}`}
                >
                  <FaPen />
                </Link>
                <a onClick={() => deleteBrand(i.id)} className="text-danger">
                  <FaTrash />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default BrandList;
